import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";

const config: LayoutConfigTypes = {
  themeName: "BxTheme",
  themeVersion: "1.0.0",
  demo: "none",
  main: {
    type: "default",
    primaryColor: "#009EF7",
    logo: {
      dark: "media/bx/header/logo.png",
      light: "media/bx/header/logo.png",
    },
  },
  illustrations: {
    set: "none",
  },
  loader: {
    logo: "media/bx/header/logo.png",
    display: true,
    type: "default",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: "font",
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
    bg: "media/bx/header/bg_header.png",
  },
  toolbar: {
    display: false,
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: "dark",
    fixed: true,
    menuIcon: "icon",
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: "fixed",
  },
  footer: {
    width: "fluid",
  },
};

export default config;
